import type { WithRequiredTheme } from '@opallabs/lapidary'

/**
 * Shared types for the Week View component tree
 */
export const enum WeekViewSortType {
  Time = 'time',
  Channel = 'channel',
  Account = 'account',
  LabelSet = 'label set',
  None = 'none',
}

export const enum WeekViewMode {
  Moment = 'moment',
  Content = 'content',
}

export const enum CoverImageDisplayMode {
  // previously "small"
  NoImage = 'no-image',
  // previously "compact"
  Standard = 'standard',
  // previously "large"
  Scaled = 'scaled',
}

export const enum LocalStorageKeys {
  CollapseContent = 'week-view-collapse-content',
  ColorBy = 'week-view-color-by',
  ContentNamePriority = 'week-view-content-name-priority',
  CoverImageDisplayMode = 'week-view-cover-image-display-mode',
  PlaceholderColor = 'week-view-placeholder-color',
  SelectedSort = 'week-view-selected-sort',
  SpanInMarketDays = 'week-view-span-in-market-days',
  ViewMode = 'week-view-view-mode',
}

export const enum ContentNamePriority {
  // default — the content (post) name is the bold primary title
  Content = 'content',
  // the moment title becomes the bold primary title instead
  Moment = 'moment',
}

export type WeekViewCategory = {
  id: string | null
  title: string
}

export interface WeekViewSort {
  id: string
  title: string
  type: WeekViewSortType
}

export const enum PlaceholderColor {
  white = 'white',
  yellow = 'yellow',
  green = 'green',
  pink = 'pink',
  purple = 'purple',
}

export type StyleProps = WithRequiredTheme
